import {
  SEARCH_INDICADORES_CHANGED,
  SEARCH_INDICADORES_LOGOUT,
} from "../../const/actionsType";

export function acSearchIndicadoresChanged(pData) {
  return {
    type: SEARCH_INDICADORES_CHANGED,
    payload: pData,
  };
}

export function acSearchIndicadoresLogout() {
  return {
    type: SEARCH_INDICADORES_LOGOUT,
  };
}
